export const industries = [
  "Aerospace and Defense",
  "Agriculture",
  "Automotive",
  "Chemicals",
  "Construction",
  "Consumer Goods",
  "Education",
  "Energy",
  "Entertainment",
  "Financial Services",
  "Food and Beverage",
  "Health Care",
  "Hospitality",
  "Information Technology",
  "Insurance",
  "Manufacturing",
  "Media",
  "Mining",
  "Pharmaceuticals",
  "Real Estate",
  "Retail",
  "Telecommunications",
  "Transportation and Logistics",
  "Utilities",
  "Waste Management",
  "Publishing",
  "Legal Services",
  "Professional Services",
  "Public Administration",
  "Sports",
  "Technology Hardware",
  "Software",
  "Biotechnology",
  "Maritime",
  "Forestry",
  "Textiles",
  "Apparel",
  "Luxury Goods",
  "Furniture",
  "Electronics",
  "Beauty and Cosmetics",
  "Fitness",
  "Health and Wellness",
  "Gaming",
  "Virtual Reality",
  "Augmented Reality",
  "Renewable Energy",
  "Environmental Services",
  "Animal Health",
  "Veterinary",
  "Recycling",
  "Space Technology",
  "Robotics",
  "Automation",
  "3D Printing",
  "Nutraceuticals",
  "E-commerce",
  "Logistics",
  "Supply Chain Management",
  "Blockchain",
  "Cryptocurrency",
  "Artificial Intelligence",
  "Machine Learning",
  "Consulting",
  "Advertising",
  "Public Relations",
  "Market Research",
  "Online Media",
  "Event Planning",
  "Travel and Tourism",
  "Air Travel",
  "Rail Transport",
  "Shipbuilding",
  "Commercial Fishing",
  "Aquaculture",
  "Forensic Science",
  "Biomedical Research",
  "Home Appliances",
  "Musical Instruments",
  "Stationery and Office Supplies",
  "Tobacco",
  "Distilleries",
  "Breweries",
  "Wineries",
  "Cannabis",
  "Petrochemicals",
  "Metallurgy",
  "Fintech",
  "Payroll Services",
  "Architectural Services",
  "Interior Design",
  "Landscape Services",
  "Photography",
  "Videography",
  "Crafts",
  "Security Services",
  "Non-Profit Organization",
  "International Affairs",
  "Diplomacy",
  "Local Government",
  "National Defense",
  "Space Exploration",
  "Material Science",
  "Quantum Computing",
];

export const data =  {
    id: 87,
    business_name: "test",
    industry_type: "Agriculture",
    email: "mailto:test@test.com",
    predicted_future: {
      A: {
        "Growth in terms of Adoption": {
          "Adoption Rate": {
            2024: "5%",
            2025: "7%",
            2026: "9%",
            2027: "11%",
            2028: "13%",
          },
          "User Base Growth": {
            2024: "3%",
            2025: "5%",
            2026: "7%",
            2027: "9%",
            2028: "11%",
          },
          "Market Penetration Rate": {
            2024: "25%",
            2025: "27%",
            2026: "30%",
            2027: "33%",
            2028: "36%",
          },
        },
      },
      B: {
        "Market Cap and Market Growth": {
          "Next 5 years": {
            "Revenue Growth": {
              2024: "$1.8 trillion",
              2025: "$2.0 trillion",
              2026: "$2.2 trillion",
              2027: "$2.4 trillion",
              2028: "$2.6 trillion",
            },
            "Market Capitalization Growth": {
              2024: "$3.5 trillion",
              2025: "$3.8 trillion",
              2026: "$4.1 trillion",
              2027: "$4.4 trillion",
              2028: "$4.7 trillion",
            },
          },
          "Past 5 years": {
            "Revenue Growth": {
              2019: "$1.2 trillion",
              2020: "$1.3 trillion",
              2021: "$1.4 trillion",
              2022: "$1.5 trillion",
              2023: "$1.6 trillion",
            },
            "Market Capitalization Growth": {
              2019: "$2.5 trillion",
              2020: "$2.6 trillion",
              2021: "$2.8 trillion",
              2022: "$3.0 trillion",
              2023: "$3.2 trillion",
            },
          },
        },
      },
      C: {
        "Future Trends": {
          "Next 5 Years": {
            Innovation:
              "Adoption of precision agriculture technologies, IoT, and drones for efficient farming practices",
            "Market Share":
              "Consolidation of small farms into larger agricultural enterprises",
            "Market Trends":
              "Shift towards sustainable and organic farming, increased focus on food security",
          },
        },
      },
      D: {
        "Risk Factors for this industry": {
          risk_factors: [
            {
              Likelihood: "High",
              Risk_Factor: "Climate Change",
              Potential_Impact: "High",
              Mitigation_Strategy:
                "Invest in climate-resilient crops and farming practices",
            },
            {
              Likelihood: "Medium",
              Risk_Factor: "Pandemics/Health Crises",
              Potential_Impact: "Moderate",
              Mitigation_Strategy:
                "Implement robust health and safety protocols",
            },
            {
              Likelihood: "Medium",
              Risk_Factor: "Market Volatility",
              Potential_Impact: "High",
              Mitigation_Strategy:
                "Diversify crop portfolio and explore export markets",
            },
            {
              Likelihood: "High",
              Risk_Factor: "Labor Shortages",
              Potential_Impact: "Moderate",
              Mitigation_Strategy: "Invest in automation and training programs",
            },
          ],
        },
      },
      Industry: "Agriculture",
      Conclusion:
        "Your inquiry opens the door to a wealth of knowledge, providing insights into the agriculture industry's development, financial intricacies, upcoming trends, and possible challenges. Join me in this fascinating exploration, shall we?",
    },
    created_date: "2024-04-30T19:18:34.727535Z",
    updated_date: "2024-04-30T19:18:34.727571Z",
  
};
